import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Gt2ApiService } from '../api/gt2-api.service';
import { ApiRoutes } from '../api/ApiRoutes';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(
    private http: HttpClient,
    private api: Gt2ApiService,
  ) {}

  public doPing() {
    return this.http.get<any>(this.api.createUrl(ApiRoutes.PING));
  }
}
